/**
//================================================================================
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:route
//
// <<Modification History>>
// Version  | Date       | Updated By               | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/07/02 | 富士通株式会社            | 新規作成
// 01.01.00 | 2022/06/27 | 富士通Japan株式会社       | 令和4年度改修対応（8月リリース）
// 01.02.00 | 2022/09/29 | 富士通Japan株式会社       | 令和4年度改修対応（2次リリース）
// 01.03.00 | 2023/04/20 | 富士通Japan株式会社       | 令和5年度改修対応（1次リリース）
// 01.04.00 | 2023/10/23 | 富士通Japan株式会社       | 令和5年度改修対応（3次リリース）
// 01.05.00 | 2024/07/09 | 富士通Japan株式会社       | 脆弱性対応（1次リリース）
// 01.06.00 | 2024/09/17 | 富士通Japan株式会社       | 令和6年度改修対応（1次リリース）
//================================================================================
 */
// URL
export const BASE_URL = (new String(location.pathname)).split("/")[1] == '' ? '' : '/' + (new String(location.pathname)).split("/")[1];
// --共通処理
export const COMMON = '/common';
// --コンポーネント
export const COMPONENTS = '/components';

// 共通
export const API_ERROR_LOG = BASE_URL + COMMON + '/errorLogs';
export const API_LIST_ITEMS = BASE_URL + COMPONENTS + '/listItems';
export const API_RADIO_ITEMS = BASE_URL + COMPONENTS + '/radioItems';
export const API_CHECKBOX_ITEMS = BASE_URL + COMPONENTS + '/checkBoxItems';
export const API_CAUTION_ITEMS = BASE_URL + COMPONENTS + '/tyuibunItems';
export const API_MESSAGE_INFO = BASE_URL + COMMON + '/messages';
export const API_ENV_PARAMS = BASE_URL + COMMON + '/envParams';
export const API_ADDRESS_INFO = BASE_URL + COMMON + '/address';
export const API_CODE_NAME = BASE_URL + COMPONENTS + '/codeName';
export const API_ZUIJI_GET_KOSU = BASE_URL + COMMON + '/getKosu';
export const API_ZUIJI_CHECK_KOKAI = BASE_URL + COMMON + '/checkKokai';
export const API_ZUIJI_KAKUHO_KOSU = BASE_URL + COMMON + '/kakuhoKosu';
export const API_ZUIJI_KAIHO_KOSU = BASE_URL + COMMON + '/kaihoKosu';

// ログイン
export const PATH_LOGIN = BASE_URL + '/login';

// ログアウト
export const PATH_LOGOUT = BASE_URL + COMMON + '/logout';

// システムエラー
export const PATH_SYSTEMERROR = '/systemError';

// ログイン画面
export const PATH_BC001_LOGINCHECK = BASE_URL + '/BC001/login';
export const PATH_BC001_GETURL = BASE_URL + '/BC001/getUrl';

// メニュー画面
export const PATH_BC002_ITIJIHOZON = BASE_URL + '/BC002/itijihozon';
export const PATH_BC002_ITIJIHOZONKANRI = BASE_URL + '/BC002/itijihozonKanri';
export const PATH_BC002_SEARCH = BASE_URL + '/BC002/search';
export const PATH_BC002_KAKUNIN = BASE_URL + '/BC002/kakunin';
export const PATH_BC002_SEARCH_ZUIJI = BASE_URL + '/BC002/searchZuiji';

// 利用者仮登録画面
export const PATH_BC003_MAILDATA = BASE_URL + '/BC003/mailData';
export const PATH_BC003_INSERTDATA = BASE_URL + '/BC003/insertInfo';
export const PATH_BC003_CHECKMAIL = BASE_URL + '/BC003/checkMailAddress';

// 利用者情報本登録
export const PATH_BC004_INIT = BASE_URL + '/BC004/init';
export const PATH_BC004_MAILSEARCH = BASE_URL + '/BC004/mailSearch';
export const PATH_BC004_INSERTDATA = BASE_URL + '/BC004/insertInfo';
export const PATH_BC004_UPDATEDATA = BASE_URL + '/BC004/updateInfo';

// 募集住宅検索画面
export const PATH_BC005_INIT = BASE_URL + '/BC005/init';
export const PATH_BC005_GET_YUSOUEND = BASE_URL + '/BC005/yusouEnd';
export const PATH_BC005_GET_TYUIPARAM = BASE_URL + '/BC005/tyuiParam';
export const PATH_BC005_GET_KUSHIBU = BASE_URL + '/BC005/kushibu';
export const PATH_BC005_COUNT = BASE_URL + '/BC005/count';
export const PATH_BC005_COUNT_OKINIIRI = BASE_URL + '/BC005/countOkiniiri';
export const PATH_BC005_GET_JYUTAKUINFO = BASE_URL + '/BC005/getList';

// 募集住宅一覧画面
export const PATH_BC006 = BASE_URL + '/BC006/init';
export const PATH_BC006_EDIT_OKINIIRI = BASE_URL + '/BC006/editOkiniiri';

// 募集住宅情報画面
export const PATH_BC007 = BASE_URL + '/BC007/init';
export const PATH_BC007_SEARCH = BASE_URL + '/BC007/search';
export const PATH_BC007_CHECK = BASE_URL + '/BC007/check';
export const PATH_BC007_ITIJIHOZON = BASE_URL + '/BC007/itijihozon';
export const PATH_BC007_EDIT_OKINIIRI = BASE_URL + '/BC007/editOkiniiri';
export const PATH_BC007_EXIST_OKINIIRI = BASE_URL + '/BC007/existOkiniiri';

// 世帯情報入力画面
export const PATH_BC008_INIT = BASE_URL + '/BC008/init';
export const PATH_BC008_LAST_MOSIKOMI = BASE_URL + '/BC008/lastMosikomi';
export const PATH_BC008_GET_MOSIKOMIKBN = BASE_URL + '/BC008/mosikomiKbn';
export const PATH_BC008_SAVE_MOSIKOMI = BASE_URL + '/BC008/saveMosikomi';
export const PATH_BC008_CHECK = BASE_URL + '/BC008/check';
export const PATH_BC008_CHECK_KOJYO = BASE_URL + '/BC008/checkKojyo';
export const PATH_BC008_SET_DATA = BASE_URL + '/BC008/setData';
export const PATH_BC008_ITIJIHOZON = BASE_URL + '/BC008/itijihozon';
export const PATH_BC008_CERTIFY = BASE_URL + '/BC008/certify';

// 申込み内容の確認画面
export const PATH_BC009_INIT = BASE_URL + '/BC009/init';
export const PATH_BC009_CHECK = BASE_URL + '/BC009/check';
export const PATH_BC009_ENTRY = BASE_URL + '/BC009/entryMosikomi';
export const PATH_BC009_SAVE = BASE_URL + '/BC009/saveMosikomi';
export const PATH_BC009_SET_DATA = BASE_URL + '/BC009/setData';

// 申込み履歴一覧画面
export const PATH_BC010 = BASE_URL + '/BC010/init';

// 申込み内容確認画面
export const PATH_BC011_INIT = BASE_URL + '/BC011/init';
export const PATH_BC011_EDIT = BASE_URL + '/BC011/edit';

// 都営住宅募集情報CSV取込み画面
export const PATH_BC012_SEARCH = BASE_URL + '/BC012/search';
export const PATH_BC012_SEARCHERR = BASE_URL + '/BC012/searchErr';
export const PATH_BC012_DOWNLOAD = BASE_URL + '/BC012/download';
export const PATH_BC012_TORIKOMI = BASE_URL + '/BC012/torikomi';

// 住宅状況情報CSV取込み画面
export const PATH_BC013_SEARCH = BASE_URL + '/BC013/search';
export const PATH_BC013_SEARCHERR = BASE_URL + '/BC013/searchErr';
export const PATH_BC013_DOWNLOAD = BASE_URL + '/BC013/download';
export const PATH_BC013_TORIKOMI = BASE_URL + '/BC013/torikomi';

// 利用者情報検索画面
export const PATH_BC015_SEARCH = BASE_URL + '/BC015/search';

// 利用者情報画面
export const PATH_BC016_INIT = BASE_URL + '/BC016/init';

// 利用者情報変更
export const PATH_BC017_INIT = BASE_URL + '/BC017/init';
export const PATH_BC017_CHECKMAIL = BASE_URL + '/BC017/checkMailAddress';
export const PATH_BC017_MAILSEARCH = BASE_URL + '/BC017/mailSearch';
export const PATH_BC017_UPDATEINFO = BASE_URL + '/BC017/updateInfo';

// 住宅状況入力
export const PATH_BC018_INIT = BASE_URL + '/BC018/init';
export const PATH_BC018_SAVE = BASE_URL + '/BC018/save';

// 住宅状況入力の確認
export const PATH_BC019_INIT = BASE_URL + '/BC019/init';
export const PATH_BC019_CHECK = BASE_URL + '/BC019/check';
export const PATH_BC019_EDIT_INFO = BASE_URL + '/BC019/editInfo';

// 利用者情報削除画面
export const PATH_BC020_INIT = BASE_URL + '/BC020/init';
export const PATH_BC020_EXISTCHECK = BASE_URL + '/BC020/existCheck';
export const PATH_BC020_CHANGINGCHECK = BASE_URL + '/BC020/changingCheck';
export const PATH_BC020_MOSIKOMICHECK = BASE_URL + '/BC020/mosikomiCheck';
export const PATH_BC020_DELETEINFO = BASE_URL + '/BC020/deleteInfo';

// 利用者情報仮変更内容確認画面
export const PATH_BC021_INIT = BASE_URL + '/BC021/init';
export const PATH_BC021_UPDATEINFO = BASE_URL + '/BC021/updateInfo';
export const PATH_BC021_UPDATECHECK = BASE_URL + '/BC021/updateCheck';

//住宅検索（随時募集・管理者用）画面
export const PATH_BC050_INIT = BASE_URL + '/BC050/init';
export const PATH_BC050_SEARCH = BASE_URL + '/BC050/search';
export const PATH_BC050_COUNT = BASE_URL + '/BC050/count';
export const PATH_BC050_GET_KUSHIBU = BASE_URL + '/BC050/kushibu';

// 住宅一覧画面(随時募集・管理者用)
export const PATH_BC051 = BASE_URL + '/BC051/init';
export const PATH_BC051_COUNT = BASE_URL + '/BC051/count'

// 住宅情報変更入力（随時募集・管理者用）
export const PATH_BC052_INIT = BASE_URL + '/BC052/init';
export const PATH_BC052_NYUKYOLIST = BASE_URL + '/BC052/nyukyoList';
export const PATH_BC052_BACK = BASE_URL + '/BC052/back';
export const PATH_BC052_CHECK = BASE_URL + '/BC052/check';

// 住宅情報変更入力（随時募集・管理者用）
export const PATH_BC053_CODENAME = BASE_URL + '/BC053/codeName';
export const PATH_BC053_JUTAKUINFO = BASE_URL + '/BC053/jutakuInfo';
export const PATH_BC053_EDITJUTAKU = BASE_URL + '/BC053/editJutaku';

// 募集住宅検索（随時募集・管理者用【代理申込み】）
export const PATH_BC055_INIT = BASE_URL + '/BC055/init';
export const PATH_BC055_GET_KUSHIBU = BASE_URL + '/BC055/kushibu';
export const PATH_BC055_COUNT = BASE_URL + '/BC055/count';

// 募集住宅検一覧（随時募集・管理者用【代理申込み】）
export const PATH_BC056 = BASE_URL + '/BC056/init';

// 募集住宅検情報（随時募集・管理者用【代理申込み】）
export const PATH_BC057_CHECK = BASE_URL + '/BC057/check';

// 世帯情報入力（随時募集・管理者用【代理申込み】）画面
export const PATH_BC058_INIT = BASE_URL + '/BC058/init';
export const PATH_BC058_GET_MOSIKOMIKBN = BASE_URL + '/BC058/mosikomiKbn';
export const PATH_BC058_SAVE_MOSIKOMI = BASE_URL + '/BC058/saveMosikomi';
export const PATH_BC058_CANCEL_MOSIKOMI = BASE_URL + '/BC058/cancelMosikomi';
export const PATH_BC058_CHECK_KOJYO = BASE_URL + '/BC058/checkKojyo';
export const PATH_BC058_UPDATETIME = BASE_URL + '/BC058/updateTime';
export const PATH_BC058_CHECK = BASE_URL + '/BC058/check';

// 世帯情報入力の確認（随時募集・管理者用【代理申込み】）画面
export const PATH_BC059_INIT = BASE_URL + '/BC059/init';
export const PATH_BC059_ENTRY = BASE_URL + '/BC059/entryMosikomi';
export const PATH_BC059_GET_NOUKETUKE = BASE_URL + '/BC059/getNoUketuke';
export const PATH_BC059_UPDATETIME = BASE_URL + '/BC059/updateTime';

// 申込み履歴検索・一覧（管理者用）
export const PATH_BC060_INIT = BASE_URL + '/BC060/init';
export const PATH_BC060_SEARCH = BASE_URL + '/BC060/search';

// 申込者情報詳細（管理者用）
export const PATH_BC061_INIT = BASE_URL + '/BC061/init';
export const PATH_BC061_EDIT = BASE_URL + '/BC061/edit';

// 稼働日付設定
export const PATH_BC090_INIT = BASE_URL + '/BC090/init';
export const PATH_BC090_UPDATE = BASE_URL + '/BC090/update';

// 画面名
export const VIEWS = [
    { name: 'SYSTEMERROR', title: 'システムエラー' },
    { name: 'BC001', title: '都営住宅入居者募集サイト' },
    { name: 'BC002', title: 'メニュー' },
    { name: 'BC003', title: '利用者仮登録' },
    { name: 'BC004', title: '利用者本登録' },
    { name: 'BC005', title: '募集住宅検索' },
    { name: 'BC006', title: '募集住宅一覧' },
    { name: 'BC007', title: '募集住宅情報' },
    { name: 'BC008', title: '世帯情報入力' },
    { name: 'BC009', title: '申込み内容の確認' },
    { name: 'BC010', title: '申込み履歴一覧' },
    { name: 'BC011', title: '申込み内容確認' },
    { name: 'BC012C1', title: '募集住宅情報CSV取込み' },
    { name: 'BC012C2', title: '募集住宅情報CSV取込み' },
    { name: 'BC013C1', title: '住宅状況情報CSV取込み' },
    { name: 'BC013C2', title: '住宅状況情報CSV取込み' },
    { name: 'BC013', title: 'パスワード再設定申請' },
    { name: 'BC014', title: 'パスワード再設定' },
    { name: 'BC015', title: '利用者情報検索' },
    { name: 'BC016', title: '利用者情報' },
    { name: 'BC017', title: '利用者情報確認・変更' },
    { name: 'BC018', title: '住宅状況入力' },
    { name: 'BC019', title: '住宅状況入力の確認' },
    { name: 'BC020', title: '利用者情報削除' },
    { name: 'BC021', title: '利用者情報仮変更内容確認' },
    { name: 'BC050', title: '住宅検索（随時募集・管理者用）' },
    { name: 'BC051', title: '住宅一覧（随時募集・管理者用）' },
    { name: 'BC052', title: '住宅情報変更入力（随時募集・管理者用）' },
    { name: 'BC053', title: '住宅情報変更内容確認（随時募集・管理者用）' },
    { name: 'BC055', title: '募集住宅検索（随時募集・管理者用【代理申込み】）' },
    { name: 'BC056', title: '募集住宅一覧（随時募集・管理者用【代理申込み】）' },
    { name: 'BC057', title: '募集住宅情報（随時募集・管理者用【代理申込み】）' },
    { name: 'BC058', title: '世帯情報入力（随時募集・管理者用【代理申込み】）' },
    { name: 'BC059', title: '世帯情報入力の確認（随時募集・管理者用【代理申込み】）' },
    { name: 'BC060', title: '申込み履歴検索・一覧（管理者用）' },
    { name: 'BC061', title: '申込者情報詳細（管理者用）' },
    { name: 'BC090', title: '稼働日付設定' },
];